// frontend/src/pages/LandingPage.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header/Header';
import Background from '../components/Background/Background';
import SearchBar, { SearchBarProps } from '../components/SearchBar/SearchBar';
import helixImg from '../assets/helix.png';
import '../styles/DoctorLandingPage.css';
import { useAuth0 } from '@auth0/auth0-react';
import { fetchWithAuth } from '../api/fetchWithAuth';
import { API_BASE } from '../config';

const LandingPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'medications' | 'history'>('medications');
  const [ssn, setSsn] = useState('');
  const navigate = useNavigate();

  const { getAccessTokenSilently } = useAuth0();

  const handleSearch = async () => {
    const ssnTrimmed = ssn.trim();
    if (!ssnTrimmed) return;
    if (!/^\d{10}$/.test(ssnTrimmed)) {
      alert('Kennitala verður að vera nákvæmlega 10 tölustafir');
      return;
    }

    try {
      const response = await fetchWithAuth(
        getAccessTokenSilently,
        `${API_BASE}/api/patients/search`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ssn: ssnTrimmed }),
        }
      );

      // If backend returns 404 for not found
      if (response.status === 404) {
        navigate('/notfound');
        return;
      }

      if (!response.ok) {
        const text = await response.text();
        throw new Error(`API ${response.status}: ${text}`);
      }

      const data = await response.json();

      // expected: { found: true, patientId: "...", name, pharmacy }
      const patientId = data.patientId as string | undefined;

      if (!patientId) {
        throw new Error('Missing patientId in search response');
      }

      navigate(`/doctor/patient/${encodeURIComponent(patientId)}`, {
        state: { name: data.name, pharmacy: data.pharmacy },
        //ATH bæta þessu við
        // state: { name: data.name, pharmacy: data.pharmacy, nextDispensionDate: data.nextDispensionDate, ssn: data.ssn, deliveryMethod: data.deliveryMethod, priority: data.priority, dispenser: data.dispenser },
      });
    } catch (error) {
      console.error('Villa við leit að sjúklingi:', error);
      navigate('/notfound');
    }
  };

  const searchProps: SearchBarProps = {
    // value: ssn,
    onChange: setSsn,
    onSearch: handleSearch,
    onMenuClick: () => console.log('menu'),
  };

  return (
    <>
      <Header center={<SearchBar {...searchProps} />} />

      <div className="tabs">
        <button
          className={`tab ${activeTab === 'medications' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('medications');
            navigate('/doctor');
          }}
        >
          Lyfjaskammtanir
        </button>
        <button
          className={`tab ${activeTab === 'history' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('history');
            navigate('/doctor/changes');
          }}
        >
          Þínar fyrri breytingar
        </button>
      </div>

      <Background>
        <img src={helixImg} className="landing-helix" alt="Helix Logo" />
        <div className="landing-box">
          <div className="landing-content">
            <h2 className="landing-heading">
              Leitaðu að sjúklingi í <br />
              lyfjaskömmtun
            </h2>
            <div className="landing-search">
              <input
                type="text"
                className="landing-input"
                placeholder="Kennitala"
                value={ssn}
                onChange={(e) => setSsn(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
              />

              <button
                type="button"
                className="landing-search-icon"
                onClick={handleSearch}
                aria-label="Leita"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.8"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                  />
                </svg>
              </button>
              <button
                className="start-subscription"
                onClick={() => {
                  navigate('/doctor/start-subscription');
                }}
              >
                Hefja skömmtun fyrir sjúkling
              </button>
            </div>
          </div>
        </div>
      </Background>
    </>
  );
};

export default LandingPage;
